import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  creditCountSelector,
  learnerEmailSelector,
  otherReasonInputSelector,
  reasonSelector,
  setConfirmModalOpen,
  setFieldErrors,
  transactionTypeSelector,
  validateCreditManagement,
} from 'features/creditManagement';
import { Icon, Tappable } from '@vectord/components';
import styles from './ManageCreditSubmitButton.module.scss';

function ManageCreditSubmitButton() {
  const dispatch = useDispatch();

  const creditCount = useSelector(creditCountSelector);
  const email = useSelector(learnerEmailSelector);
  const reason = useSelector(reasonSelector);
  const transactionType = useSelector(transactionTypeSelector);
  const otherReasonInput = useSelector(otherReasonInputSelector);

  const handleClickAction = useCallback(() => {
    const response = validateCreditManagement(
      creditCount,
      email,
      otherReasonInput,
      reason
    );

    if (response.success === false) {
      dispatch(setFieldErrors(response.message));
      return;
    }

    dispatch(setFieldErrors(null));
    dispatch(setConfirmModalOpen(true));
  }, [creditCount, dispatch, email, otherReasonInput, reason]);

  return (
    <Tappable
      className={classNames('btn btn-primary m-t-20', styles.root)}
      onClick={handleClickAction}
    >
      <Icon
        name={transactionType === 'ADD' ? 'add' : 'clear'}
        className="m-r-5"
      />{' '}
      {transactionType === 'ADD' ? 'Add' : 'Deduct'}
      <span className="m-l-5">Credit</span>
    </Tappable>
  );
}

export default ManageCreditSubmitButton;
